<template>
    <ModalBackground class="session-expired-modal" :hideOnClickOutside="false">
        <div class="session-expired">
            <div>
                <h2>{{$t('modals.session-expired.title')}}</h2>
                <p>{{$t('modals.session-expired.subTitle')}}</p>
                <footer>
                    <PrimaryButton :text="$t('modals.session-expired.logout')" icon="s-icon-logout" class="tertiary reverse no-border logout-button" @click="logout" :naked="true"/>
                </footer>
            </div>
        </div>
    </ModalBackground>
</template>

<i18n>
{
    "en": {
        "modals": {
            "session-expired": {
                "title": "Session expired",
                "subTitle": "For security reasons, we automatically log users off after more than one hour of inactivity. If you were in the middle of a campaign, it was automatically saved and can be viewed in the same browser when you log back in.",
                "logout": "Logout"
            }
        }
    },
    "es": {
        "modals": {
            "session-expired": {
                "title": "La sesión ha expirado",
                "subTitle": "Por razones de seguridad, cerramos automáticamente la sesión de los usuarios después de más de una hora de inactividad. Si estabas en medio de una campaña, ésta se guardó automáticamente y puedes verla en el mismo navegador cuando vuelvas a conectarte.",
                "logout": "Cierre de sesión"
            }
        }
    },
    "fr": {
        "modals": {
            "session-expired": {
                "title": "Session expirée",
                "subTitle": "Pour des raisons de sécurité, nous déconnectons automatiquement les utilisateurs après plus d'une heure d'inactivité. Si vous étiez au milieu d'une campagne, celle-ci a été automatiquement sauvegardée et peut être consultée dans le même navigateur lorsque vous vous reconnectez.",
                "logout": "Déconnexion"
            }
        }
    },
    "pt": {
        "modals": {
            "session-expired": {
                "title": "Sessão expirou",
                "subTitle": "Por razões de segurança, desligamos automaticamente os utilizadores após mais de uma hora de inactividade. Se estava no meio de uma campanha, foi automaticamente guardado e pode ser visualizado no mesmo browser quando volta a iniciar a sessão.",
                "logout": "Sair"
            }
        }
    },
    "de": {
        "modals": {
            "session-expired": {
                "title": "Sitzung abgelaufen",
                "subTitle": "Aus Sicherheitsgründen melden wir Benutzer nach mehr als einer Stunde Inaktivität automatisch ab. Wenn Sie sich mitten in einer Kampagne befanden, wurde diese automatisch gespeichert und kann im selben Browser angezeigt werden, wenn Sie sich wieder anmelden.",
                "logout": "Abmeldung"
            }
        }
    },
    "nl": {
        "modals": {
            "session-expired": {
                "title": "Sessie afgelopen",
                "subTitle": "Om veiligheidsredenen loggen wij gebruikers automatisch uit na meer dan een uur inactiviteit. Als u midden in een campagne zat, werd deze automatisch opgeslagen en kunt u deze in dezelfde browser bekijken als u weer inlogt.",
                "logout": "Uitloggen"
            }
        }
    }
}
</i18n>

<script>
import Card from '@/components/v3/cards/Card.vue'
import PrimaryButton from '@/components/v3/buttons/PrimaryButton'
import ModalBase from '@/modules/modals/components/ModalBase.vue'
import ModalBackground from '@/modules/modals/components/ModalBackground.vue'

export default {
    extends: ModalBase,
    components: {
        Card,
        PrimaryButton,
        ModalBase,
        ModalBackground,
    },
    methods: {
        logout() {
            this.$eventBusEmit('logout')
            sessionStorage.setItem('cv-user-id', '')
            sessionStorage.setItem('cv-user-language', '')
            sessionStorage.setItem('cv-user-token', '')
            localStorage.setItem('cv-user-id', '')
            localStorage.setItem('cv-user-language', '')
            localStorage.setItem('cv-user-token', '')
            window.open(this.$serverRootUrl, '_self')
        }
    }
}
</script>

<style lang="stylus">
@import "~assets/v3/css/variables.styl";

.session-expired-modal

    .session-expired
        width auto
        background-color $color-primary-text
        height fit-content
        border-radius 5px
        box-shadow 0 4px 4px rgba(0, 0, 0, 0.2)
        display flex
        flex-direction column
        justify-content center
        align-items center
        box-sizing border-box
        padding 36px
        max-width 476px

        h2
            margin-top 0
            margin-bottom 36px
            color $color-primary

        footer
            display flex
            flex-direction row
            margin-top 48px
            justify-content flex-end

            // .primary-button
            //     background-color $color-primary-text
            //     color $color-primary
</style>



// WEBPACK FOOTER //
// src/modules/app/components/modals/SessionExpiredModal.vue